import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M12 7.512h1.5m-1.5 3h1.5m-7.5 3h7.5m-7.5 3h7.5m3-9h3.375c.621 0 1.125.503 1.125 1.125v9.375a2.25 2.25 0 0 1-2.25 2.25M16.5 7.512v10.5a2.25 2.25 0 0 0 2.25 2.25M16.5 7.512V4.887c0-.622-.504-1.125-1.125-1.125H4.125C3.504 3.762 3 4.265 3 4.887v13.125a2.25 2.25 0 0 0 2.25 2.25h13.5M6 7.512h3v3H6z"
    }, null, -1)
  ])))
}
export default { render: render }